import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: any) => {
    return {
        contentTitle: {
            textAlign: 'center',
            marginBottom: '70px',
            font: `700 19px/25px "Montserrat"`,
            color: theme.custom.colors.primary,
        },
        iconCloseIcon: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: '20px',
            cursor: 'pointer'
        },
        listType: {
            display: 'flex',
            width: '70%',
            justifyContent: 'center',
            margin: '0 auto',
        },
        typeTitle: {
            font: theme.custom.font.headingMontserrat3,
            marginBottom: 15
        },
        icon: {
            height: "32px",
            width: "32px"
        },
        itemType: {
            borderRadius: 10,
            textAlign: 'center',
            padding: '24px 9px',
            cursor: 'pointer',
            '&:not(:last-child)': {
                marginRight: 64
            },
            '& img': {
                marginBottom: 27
            },
            boxShadow: '1px 1px 6px rgba(56, 25, 81, 0.25)',
            '&:hover': {
                border: `1px solid ${theme.custom.colors.purp}`
            }
        },
        itemType2: {
            borderRadius: 10,
            textAlign: 'center',
            padding: '24px 40px',
            cursor: 'pointer',
            '& img': {
                marginBottom: 27
            },
            boxShadow: '1px 1px 6px rgba(56, 25, 81, 0.25)',
            '&:hover': {
                border: `1px solid ${theme.custom.colors.purp}`
            }
        },
        typeDes: {
            font: 'normal normal 400 14px/18px Montserrat',
            marginBottom: 13,
            color: theme.custom.colors.midBlack,
        },
        bodyModalList: {
            padding: '24px',
            height: '81%',
            overflowY: 'scroll'
        },
        nextBtn: {
            '& button': {
                height: 32,
                background: theme.custom.colors.purple,
                fontWeight: 'bold',
                color: theme.custom.colors.white,
                fontSize: theme.custom.fontSize.size16,
                fontFamily: theme.custom.fontFamily.title,
                boxShadow: 'none',
                textTransform: 'inherit',
                borderRadius: '30px',
                '& img': {
                    marginLeft: 8,
                },
                '&:hover': {
                    background: theme.custom.colors.purple,
                },
            },
        },
        selected: {
            border: `1px solid ${theme.custom.colors.purp}`
        },
        footerModal: {
            height: '19%',
            padding: '24px 119px 55px',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            font: 'normal normal 500 16px/24px Public-Sans',
        },
        buttonBack: {
            '& button': {
                height: 32,
                background: theme.custom.colors.borderGrey,
                fontWeight: 'bold',
                fontSize: theme.custom.fontSize.size16,
                fontFamily: 'Montserrat',
                boxShadow: 'none',
                textTransform: 'inherit',
                borderRadius: '30px',
                color: '#333333',
                marginRight: 24,
                '&:hover': {
                    background: theme.custom.colors.borderGrey,
                },
            },
        },
    };
});
